export default "__VITE_ASSET__uHT_MyZt__"